import { createStore } from "vuex";
import auth from "./auth";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: false,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showTransferNavbar: false,
    showFooter: true,
    showMain: true,
    layout: "default",
    environment: localStorage.getItem("environment") || "sandbox",
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    sidebarMinimize(state) {
      let sidenav_show = document.querySelector("#app");
      if (state.isPinned) {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        sidenav_show.classList.remove("g-sidenav-hidden");
        state.isPinned = true;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    setShowNavbar(state, payload) {
      state.showNavbar = payload;
    },
    setShowSidenav(state, payload) {
      state.showSidenav = payload;
    },
    setEnvironment(state, payload) {
      state.environment = payload;
      localStorage.setItem("environment", payload);
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    changeEnvironment({ commit }, environment) {
      commit("setEnvironment", environment);
    },
  },
  getters: {
    currentEnvironment: (state) => state.environment,
    isSandboxMode: (state) => state.environment === "sandbox",
    statusKyb: () => localStorage.getItem("merchantKyb"),
  },
  modules: {
    auth,
  },
});
